import { createApp,defineAsyncComponent  } from 'vue'
import App from './App.vue'
import { setupStore } from './store' // 引入pinia
import router from './router'
import ElementPlus, { ElMessage } from 'element-plus'
//引入所有图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import locale from 'element-plus/es/locale/lang/zh-cn'
import '@/styles/index.scss' // global css
// import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/src/index.scss'
import '@/utils/protocolcheck' // 引入检查协议库，用来唤起美吉网盘
import '@/permission' // permission control
// 完整导入 表格库
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
 import VXETable from 'vxe-table'
 import 'vxe-table/lib/style.css'
// 引入新的主题样式
import './styles/skin/index.scss'
import { fetchReportErrorLog } from '@/api/projectCenter/common'
import 'virtual:svg-icons-register'

// 全局配置
VXETable.setup({
  table: {
    columnConfig: {
      resizable: true, // 列宽拖动
    },
  },
})


// const app = createApp(App)

// setupStore(app)
// app.config.globalProperties.$message = ElMessage
// app.use(router)
// app.use(ElementPlus, { locale })
// app.use(VxeUI).use(VXETable)

// // 动态导入 MjCustomTable 组件
// // const MjCustomTableComp = defineAsyncComponent(() => import("remote_app/MjCustomTable"));
// // app.component("MjCustomTableComp", MjCustomTableComp);
// app.mount('#app')


// 创建实例
const setupAll = async () => {
  const app = createApp(App)
  setupStore(app)
  app.config.globalProperties.$message = ElMessage
  app.use(router)
  app.use(ElementPlus, { locale,namespace: 'ep'})
  app.use(VxeUI).use(VXETable)
  app.mount('#app')
  //全局注册图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  // 生产环境再去做上传错误处理
const NODE_ENV = import.meta.env.VITE_APP_ENV
if (NODE_ENV === 'production' || NODE_ENV === 'local') {
  // 3. 捕获Vue异常
  app.config.errorHandler = (err, vm, info) => {
    // 参数检查
    if (!err || !vm || !info) {
      console.error('Vue.config.errorHandler: 参数无效', err, vm, info);
      return;
    }

    // 构建错误日志对象
    let params = {
      message: err.message || '未知错误',
      url: window.location.href,
      type: 'Vue异常',
      stack: err.stack || '无堆栈信息',
      userAgent: navigator.userAgent || '未知用户代理',
      systemType: 'vip',
      urlOrigin: window.location.origin,
      account: 'main.ts',
    };

    console.log('捕获的异常类型：Vue异常', err);

    // 上报错误日志
    // fetchReportErrorLog(params)
    //   .then((res) => {
    //     const { code } = res;
    //     if (code === 0) {
    //       console.log('上报成功')
    //     } 
    //   })
  };
  }
  
}
setupAll()
